<template>
    <table>
      <tbody>
        <tr>
         <td :colspan="datasource.children && datasource.children.length ? datasource.children.length*2 : null">
          <div class="node" :id="datasource.id" @click.stop="handleClick(datasource);">
            <div 
              class="node-content" 
              :class="active == datasource.id ? 'active-node' : ''" 
            >
              <slot 
                :node-data="datasource" 
                :class-data="(datasource.name.toLowerCase()).includes(search_text) ? 'active':'inactive'"
              >
                <div class="content" >{{ datasource.name }}</div>
              </slot>
            </div>
            <v-icon
              v-if="expandable && datasource.children && datasource.children.length > 0"
              medium
              @click.stop="expand_node"
            >
              {{ expand? 'mdi-chevron-down':'mdi-chevron-up'}}
            </v-icon>
          </div>
          
         </td>
        </tr>
        <template v-if="expand && datasource.children && datasource.children.length">
          <tr class="lines">
            <td :colspan="datasource.children.length*2">
              <div class="downLine"></div>
            </td>
          </tr>
          <tr class="lines">
            <td class="rightLine"></td>
           <template v-for="n in (datasource.children.length-1)">
              <td class="leftLine topLine"></td>
              <td class="rightLine topLine"></td>
           </template>
            <td class="leftLine"></td>
          </tr>
          <tr class="nodes">
            <td colspan="2" v-for="child in datasource.children" :key="child.id">
              <node 
                :datasource="child" 
                :search_text="search_text"
                :handle-click="handleClick" 
                :expandable="expandable" 
                :active="active"
                @expanded="expand_event"
              >
                <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
                  <slot :name="slot" v-bind="scope"/>
                </template>
              </node>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </template>
  
<script>
  export default {
    name: 'OrganizationChartNode',
    components: {
      node: () => import('@/components/org_chart/OrganizationChartNode'), 
    },
    props: {
      datasource: Object,
      handleClick: Function,
      expandable: {
        type: Boolean,
        required: false,
        default: false
      },
      active: {
        required: false,
      },
      search_text: {
        required: false,
      }
    },
    data: () => ({
      expand: true,
    }),
    methods: {
      expand_node() {
        this.expand = !this.expand;
        this.expand_event(this.datasource,this.expand);
      },
      expand_event(data,expand){
        this.$emit('expanded',data,expand);
      },
    }
  };
</script>
  
<style lang="scss">
  @import "@/sass/orgchart.scss";
</style>